import * as Global from 'styles/global/global.styles';
import { zIndex } from '../global/global.styles';

export function Container() {
	return {
		maxHeight: Global.footer().height,
		height: Global.footer().height,
		borderTop: '1px solid #c8c8c8',
		backgroundColor: '#243781',
		width: 'auto',
	};
}
